import React from 'react';
import {useSession} from '../../hooks/useSession';

interface SessionHandlerProps {
  children: React.ReactNode;
  token?: string;
  loadingComponent?: React.ReactNode;
  errorComponent?: React.ReactNode;
  persistSession?: boolean;
}

export function SessionHandler({
  children,
  token,
  loadingComponent = <div>Loading...</div>,
  errorComponent = <div>Error</div>,
  persistSession = true,
}: SessionHandlerProps) {
  const {session, loading} = useSession(token, {persistSession});

  if (loading) {
    return <>{loadingComponent}</>;
  }

  if (!session) {
    return <>{errorComponent}</>;
  }

  return <>{children}</>;
}
